"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireWildcard(require("react"));
var _FlexRow = require("../../layout/flex/FlexRow");
var _ = require("../..");
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _BaseButton = _interopRequireWildcard(require("../../../components/controls/buttons/BaseButton"));
var _jsxRuntime = require("react/jsx-runtime");
var Container = _styledComponents.default.div.withConfig({
  displayName: "ExpandableContainer__Container",
  componentId: "sc-qaag1i-0"
})(["background-color:", ";border-radius:", ";padding:", ";margin:", " 0px;width:100%;display:flex;flex-direction:column;overflow-wrap:break-word;", ";"], _tokens.default.sky.sys.color.background.primary['1'], _tokens.default.sky.sys.size.borderradius[2], _tokens.default.sky.sys.spacing['400'], _tokens.default.sky.sys.spacing['100'], function (_ref) {
  var isExpanded = _ref.isExpanded;
  return isExpanded ? '' : 'height: 52px';
});
var HeaderRow = (0, _styledComponents.default)(_FlexRow.FlexRow).withConfig({
  displayName: "ExpandableContainer__HeaderRow",
  componentId: "sc-qaag1i-1"
})(["justify-content:space-between;align-items:center;width:100%;margin-bottom:", ";"], function (_ref2) {
  var isExpanded = _ref2.isExpanded;
  return isExpanded ? _tokens.default.sky.sys.spacing['100'] : _tokens.default.sky.sys.spacing['0'];
});
var PrimaryTextWrapper = (0, _styledComponents.default)(_FlexRow.FlexRow).withConfig({
  displayName: "ExpandableContainer__PrimaryTextWrapper",
  componentId: "sc-qaag1i-2"
})(["width:", ";height:", ";"], function (_ref3) {
  var isExpanded = _ref3.isExpanded;
  return isExpanded ? '100%' : '200px';
}, _tokens.default.sky.sys.spacing['500']);
var SecondaryTextWrapper = (0, _styledComponents.default)(_FlexRow.FlexRow).withConfig({
  displayName: "ExpandableContainer__SecondaryTextWrapper",
  componentId: "sc-qaag1i-3"
})(["width:'100%';height:", ";"], _tokens.default.sky.sys.spacing['500']);
var ActionButton = (0, _styledComponents.default)(_BaseButton.default).withConfig({
  displayName: "ExpandableContainer__ActionButton",
  componentId: "sc-qaag1i-4"
})(["background-color:transparent;.left-icon svg path{fill:", ";}&:hover,&.focus-ring{background-color:", ";.left-icon svg path{fill:", ";}}height:", ";"], _tokens.default.sky.sys.color.iconfill.onlight, _tokens.default.sky.sys.color.background.neutral['1'], _tokens.default.sky.sys.color.iconfill.onlight, _tokens.default.sky.sys.spacing['500']);
var ExpandableContainer = function ExpandableContainer(_ref4) {
  var primaryText = _ref4.primaryText,
    secondaryText = _ref4.secondaryText,
    _ref4$isExpandable = _ref4.isExpandable,
    isExpandable = _ref4$isExpandable === void 0 ? true : _ref4$isExpandable,
    onActionClick = _ref4.onActionClick,
    _ref4$icon = _ref4.icon,
    icon = _ref4$icon === void 0 ? 'edit' : _ref4$icon,
    children = _ref4.children;
  var _ref5 = (0, _react.useState)(false),
    _ref6 = _slicedToArray(_ref5, 2),
    isExpanded = _ref6[0],
    setIsExpanded = _ref6[1];
  var toggleExpand = function toggleExpand() {
    return setIsExpanded(!isExpanded);
  };
  var secondaryTextEmpty = !secondaryText || secondaryText.trim() === '';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Container, {
    isExpanded: isExpanded,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(HeaderRow, {
      isExpanded: isExpanded,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexRow.FlexRow, {
        gap: "l",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(PrimaryTextWrapper, {
          isExpanded: isExpanded,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Label, {
            ellipsis: true,
            tooltipOnEllipsis: true,
            children: primaryText
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SecondaryTextWrapper, {
          children: !isExpanded && /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Text, {
            ellipsis: true,
            tooltipOnEllipsis: true,
            children: secondaryText
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexRow.FlexRow, {
        gap: "s",
        justifyContent: "flex-end",
        children: [!secondaryTextEmpty && isExpandable && /*#__PURE__*/(0, _jsxRuntime.jsx)(ActionButton, {
          noMargin: true,
          emphasis: _BaseButton.EMPHASIS.LOW,
          onClick: toggleExpand,
          children: isExpanded ? 'View Less' : 'View More'
        }), onActionClick && /*#__PURE__*/(0, _jsxRuntime.jsx)(ActionButton, {
          iconOnly: true,
          noMargin: true,
          emphasis: _BaseButton.EMPHASIS.LOW,
          leftIcon: icon,
          "data-cy": 'actions',
          onClick: onActionClick
        })]
      })]
    }), isExpanded && children ? children : isExpanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Text, {
      children: secondaryText
    }) : null]
  });
};
var _default = exports.default = ExpandableContainer;